import React, {
  createContext,
  ReactNode,
  useEffect,
  useMemo,
  useState
} from "react";
import { ThemeProvider } from "@mui/material/styles";
import { $mainThemeMode, getMainTheme } from "@brickken/dapp-theme";
import { PaletteMode } from "@mui/material";

export interface IColorModeProviderProps {
  children: ReactNode | ReactNode[];
}
export const ColorModeContext = createContext({
  toggleColorMode: () => {}
});
export const ColorModeProvider = ({ children }: IColorModeProviderProps) => {
  const [mode, setMode] = useState<"light" | "dark">("dark");
  const colorMode = {
    toggleColorMode: () => {
      setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
    }
  };
  useEffect(() => {
    $mainThemeMode.next(mode);
  }, [mode]);
  useEffect(() => {
    const subscriptions = $mainThemeMode.subscribe((mainMode: PaletteMode) => {
      setMode(mainMode);
    });
    return () => subscriptions.unsubscribe();
  }, []);

  const customTheme = useMemo(() => {
    return getMainTheme(mode);
  }, [mode]);
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={customTheme}>{children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
};
